import { Box, Fade, Tooltip, Typography } from '@mui/material'
import CustomChip from '../../../../../shared/components/CustomChip'
import HighlightIcon from '../../../../../shared/components/icons/HighlightIcon'
import VisibilityIcon from '../../../../../shared/components/icons/VisibilityIcon'

interface CourseTitleCellProps {
  params: any
  onHighlight: (id: number, isHighlight: boolean) => void
}

const CourseTitleCell = ({ params, onHighlight }: CourseTitleCellProps) => {
  const getStatusChip = (status: number) => {
    switch (status) {
      case 0:
        return <CustomChip size="small" color="secondary" />
      case 1:
        return <CustomChip size="small" color="primary" />
      case 2:
        return <CustomChip size="small" color="default" />
      default:
        return <CustomChip size="small" color="default" />
    }
  }

  return (
    <Box display="flex" alignItems="center" gap={1}>
      {getStatusChip(params.status)}
      <Tooltip placement="bottom-start" TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title={params.title}>
        <Typography
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            maxWidth: 300,
            fontWeight: 300,
            '@media (max-width: 600px)': {
              maxWidth: 150
            }
          }}
        >
          {params.title}
        </Typography>
      </Tooltip>
      <HighlightIcon id={params.id} isHighlight={!!params.highlight} handleClick={onHighlight} />
      <VisibilityIcon id={params.visibility} />
    </Box>
  )
}

export default CourseTitleCell
